import * as types from "./types";
import handleResponse from "../../shared/handleResponse";

export type SubCategory = {
  title: string;
  uuid: string;
  default_image_filename: string;
  default_offer_text: string;
  default_layout: number;
  social_feeds: boolean;
};

type SubCategoryProps = { subCategories: Array<SubCategory> };

const setLoading = (value: boolean): object => ({
  type: types.SET_LOADING,
  payload: value,
});

const setSubCategories = (categories: Array<SubCategory>) => ({
  type: types.SET_SUB_CATEGORIES,
  payload: categories,
});

const subCategoriesSuccess = (dispatch: Function) => ({
  subCategories,
}: SubCategoryProps) => {
  dispatch(setSubCategories(subCategories));
};

export const getSubCategories = () => async (dispatch: Function) => {
  dispatch(setLoading(true));
  const onSuccess = subCategoriesSuccess(dispatch);
  await handleResponse("get", "/sub_categories", onSuccess, dispatch, {});
  dispatch(setLoading(false));
};
